import { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import SubscriptionTable from '../../components/admin/SubscriptionTable';
import axios from 'axios';
import './AdminStyles.css';

// Используем относительный путь для админ панели
const API_URL = '/api';

function AdminSubscriptionsPage() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);

  useEffect(() => {
    fetchSubscriptions();
  }, [page]);

  const fetchSubscriptions = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('admin_token');
      
      const response = await axios.get(`${API_URL}/admin/subscriptions?page=${page}&limit=50`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setSubscriptions(response.data.subscriptions);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch subscriptions:', err);
      setError('Не удалось загрузить подписки');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout currentPage="subscriptions">
      <div className="admin-page">
        <div style={{ marginBottom: '32px' }}>
          <h1 className="text-3xl font-bold text-gray-900" style={{ marginBottom: '8px' }}>Подписки</h1>
          <p className="text-gray-500">Список всех подписок пользователей</p>
        </div>

        <div className="admin-table">
          {error ? (
            <div className="empty-state">
              <p className="empty-state-title text-red-500">{error}</p>
              <button onClick={fetchSubscriptions} className="admin-button admin-button-primary" style={{ marginTop: '16px' }}>
                Повторить
              </button>
            </div>
          ) : (
            <SubscriptionTable subscriptions={subscriptions} loading={loading} />
          )}
        </div>
      </div>
    </AdminLayout>
  );
}

export default AdminSubscriptionsPage;

